export default function toPDFMakeData(props: any) {
  return {
    content: [
      {
        alignment: `center`,
        decorationColor: ``,
        color: ``,
        bold: `true`,
        decoration: ``,
        text: `ใบรับรองแพทย์`,
        preserveLeadingSpaces: true,
        width: `auto`,
        pageBreak: ``,
        decorationStyle: ``,
        fontSize: `18`,
      },
      {
        width: `auto`,
        text: ` `,
        preserveLeadingSpaces: true,
        alignment: `left`,
        color: ``,
        fontSize: 15,
        decorationColor: ``,
        decorationStyle: ``,
        bold: false,
        pageBreak: ``,
        decoration: ``,
      },
      {
        columns: [
          {
            text: ``,
            decorationColor: ``,
            fontSize: 15,
            decoration: ``,
            color: ``,
            decorationStyle: ``,
            pageBreak: ``,
            bold: false,
            width: 400,
            alignment: `left`,
            preserveLeadingSpaces: true,
          },
          {
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            decorationStyle: ``,
            bold: true,
            width: `auto`,
            text: `วันที่`,
            pageBreak: ``,
            color: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
          },
          {
            decorationColor: ``,
            decorationStyle: ``,
            alignment: `left`,
            decoration: ``,
            text: ``,
            color: ``,
            fontSize: 15,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            width: 5,
            bold: false,
          },
          {
            width: `auto`,
            color: ``,
            bold: true,
            decorationColor: ``,
            alignment: `center`,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            decorationStyle: ``,
            text: props.items?.formatCreatedDateTH,
            fontSize: 15,
            decoration: ``,
          },
        ],
      },
      {
        preserveLeadingSpaces: true,
        bold: false,
        width: `auto`,
        alignment: `left`,
        text: ` `,
        decorationColor: ``,
        pageBreak: ``,
        fontSize: 15,
        decorationStyle: ``,
        color: ``,
        decoration: ``,
      },
      {
        columns: [
          {
            pageBreak: ``,
            decoration: ``,
            alignment: `left`,
            text: ``,
            preserveLeadingSpaces: true,
            color: ``,
            decorationStyle: ``,
            decorationColor: ``,
            width: 40,
            bold: false,
            fontSize: 15,
          },
          {
            decoration: ``,
            width: `auto`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            color: ``,
            alignment: `left`,
            decorationColor: ``,
            pageBreak: ``,
            text: `แพทย์ผู้ตรวจ`,
            bold: false,
          },
          {
            text: ``,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            pageBreak: ``,
            alignment: `center`,
            bold: false,
            width: 10,
            fontSize: 15,
            decorationColor: ``,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                decorationStyle: ``,
                margin: [0, 0, 0, -15],
                width: `auto`,
                color: ``,
                alignment: `left`,
                text: props.items?.doctorName,
                bold: false,
                preserveLeadingSpaces: true,
                decoration: ``,
                pageBreak: ``,
                decorationColor: ``,
                fontSize: 15,
              },
              {
                fontSize: 15,
                text: `...........................................................................`,
                pageBreak: ``,
                bold: false,
                margin: [0, 0, 0, 0],
                decorationColor: ``,
                preserveLeadingSpaces: true,
                width: `auto`,
                color: ``,
                alignment: `left`,
                decorationStyle: ``,
                decoration: ``,
              },
            ],
          },
          {
            pageBreak: ``,
            decoration: ``,
            text: ``,
            alignment: `left`,
            decorationStyle: ``,
            color: ``,
            bold: false,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            width: 15,
            fontSize: 15,
          },
          {
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            color: ``,
            width: `auto`,
            alignment: `left`,
            fontSize: 15,
            bold: false,
            text: `เลขใบประกอบวิชาชีพ`,
            decorationStyle: ``,
            pageBreak: ``,
          },
          {
            decorationColor: ``,
            width: 10,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            fontSize: 15,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            alignment: `left`,
            text: ``,
            bold: false,
          },
          {
            stack: [
              {
                pageBreak: ``,
                bold: false,
                fontSize: 15,
                decorationColor: ``,
                text: props.items?.doctorCertNumber ? props.items?.doctorCertNumber : " ",
                preserveLeadingSpaces: true,
                color: ``,
                decorationStyle: ``,
                margin: [0, 0, 0, -15],
                alignment: `left`,
                width: `auto`,
                decoration: ``,
              },
              {
                margin: [0, 0, 0, 0],
                decoration: ``,
                decorationStyle: ``,
                width: `auto`,
                preserveLeadingSpaces: true,
                fontSize: 15,
                color: ``,
                bold: false,
                text: `.........................................`,
                decorationColor: ``,
                pageBreak: ``,
                alignment: `left`,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            pageBreak: ``,
            text: `ตรวจพบว่า  `,
            alignment: `left`,
            color: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            decorationColor: ``,
            fontSize: 15,
            width: `auto`,
            bold: false,
            decoration: ``,
          },
          {
            decorationColor: ``,
            preserveLeadingSpaces: true,
            color: ``,
            text: ``,
            bold: false,
            pageBreak: ``,
            width: 10,
            decorationStyle: ``,
            alignment: `left`,
            fontSize: 15,
            decoration: ``,
          },
          {
            stack: [
              {
                decorationStyle: ``,
                text: props.items?.patientInfo?.full_name,
                pageBreak: ``,
                fontSize: 15,
                width: `auto`,
                decorationColor: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
                decoration: ``,
                color: ``,
                bold: false,
                alignment: `left`,
              },
              {
                text: `......................................................................................................................................................................................`,
                decorationColor: ``,
                alignment: `left`,
                width: `auto`,
                decorationStyle: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                color: ``,
                bold: false,
                margin: [0, 0, 0, 0],
                decoration: ``,
                pageBreak: ``,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            pageBreak: ``,
            preserveLeadingSpaces: true,
            text: `หมายเลขประจำตัวประชาชน / เลขที่หนังสือเดินทาง / อื่นๆ`,
            decorationStyle: ``,
            width: `auto`,
            decorationColor: ``,
            bold: false,
            decoration: ``,
            color: ``,
            fontSize: 15,
            alignment: `left`,
          },
          {
            decorationColor: ``,
            width: 10,
            bold: false,
            pageBreak: ``,
            decoration: ``,
            text: ``,
            color: ``,
            fontSize: 15,
            decorationStyle: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                fontSize: 15,
                alignment: `left`,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                decoration: ``,
                text:
                  props.items?.patientInfo?.citizen_no === "" ||
                  props.items?.patientInfo?.citizen_no === "Non citizen identity"
                    ? props.items?.patientInfo?.citizen_passport === "" ||
                      props.items?.patientInfo?.citizen_passport === "Non citizen identity"
                      ? " "
                      : props.items?.patientInfo?.citizen_passport
                    : props.items?.patientInfo?.citizen_no,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `........................................................................................................`,
                alignment: `left`,
                decoration: ``,
                margin: [0, 0, 0, 0],
                width: `auto`,
                decorationColor: ``,
                preserveLeadingSpaces: true,
                fontSize: 15,
                pageBreak: ``,
                decorationStyle: ``,
                color: ``,
                bold: false,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            fontSize: 15,
            text: `อายุ `,
            color: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            width: `auto`,
            decorationColor: ``,
            pageBreak: ``,
            bold: false,
            alignment: `left`,
          },
          {
            decoration: ``,
            color: ``,
            bold: false,
            width: 10,
            decorationColor: ``,
            fontSize: 15,
            decorationStyle: ``,
            alignment: `left`,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            text: ``,
          },
          {
            stack: [
              {
                color: ``,
                decorationStyle: ``,
                margin: [0, 0, 0, -15],
                text: `${props.items?.ageYear} ปี ${props.items?.ageMonth} เดือน ${props.items?.ageDay} วัน`,
                preserveLeadingSpaces: true,
                fontSize: 15,
                width: `auto`,
                decoration: ``,
                decorationColor: ``,
                pageBreak: ``,
                alignment: `left`,
                bold: false,
              },
              {
                fontSize: 15,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                decoration: ``,
                width: `auto`,
                bold: false,
                text: `...................................................................................`,
                margin: [0, 0, 0, 0],
                decorationColor: ``,
                color: ``,
                alignment: `left`,
              },
            ],
          },
          {
            decorationColor: ``,
            width: 15,
            alignment: `left`,
            pageBreak: ``,
            decoration: ``,
            decorationStyle: ``,
            bold: false,
            text: ``,
            color: ``,
            margin: [0, 0, 0, 0],
            fontSize: 15,
            preserveLeadingSpaces: true,
          },
          {
            alignment: `left`,
            fontSize: 15,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            pageBreak: ``,
            text: `หมายเลขผู้ป่วย    `,
            bold: false,
            color: ``,
            width: `auto`,
            decoration: ``,
          },
          {
            width: 10,
            bold: false,
            color: ``,
            decorationStyle: ``,
            text: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            alignment: `left`,
            pageBreak: ``,
            decorationColor: ``,
            fontSize: 15,
          },
          {
            stack: [
              {
                width: `auto`,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                alignment: `left`,
                color: ``,
                decorationColor: ``,
                decorationStyle: ``,
                decoration: ``,
                margin: [0, 0, 0, -15],
                text: props.items?.patientInfo?.hn,
              },
              {
                decoration: ``,
                decorationColor: ``,
                text: `....................................................................`,
                decorationStyle: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
                width: `auto`,
                alignment: `left`,
                pageBreak: ``,
                color: ``,
                bold: false,
                fontSize: 15,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            text: `เข้ารับการรักษาในฐานะ`,
            decoration: ``,
            decorationStyle: ``,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            color: ``,
            fontSize: 15,
            width: `auto`,
            decorationColor: ``,
            bold: false,
            margin: [0, 0, 0, 0],
          },
          {
            pageBreak: ``,
            color: ``,
            decorationColor: ``,
            fontSize: 15,
            margin: [0, 0, 0, 0],
            text: ``,
            bold: false,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            width: 10,
            decoration: ``,
            alignment: `left`,
          },
          {
            stack: [
              {
                decorationStyle: ``,
                preserveLeadingSpaces: true,
                fontSize: 15,
                alignment: `left`,
                margin: [0, 0, 0, -15],
                decorationColor: ``,
                pageBreak: ``,
                bold: false,
                width: `auto`,
                decoration: ``,
                color: ``,
                text: `${props.items?.patientVisitType[0]} ${
                  props.items?.encounterInfo?.type === "OPD"
                    ? `(EN: ${props.items?.encounterInfo?.number})`
                    : `(AN: ${props.items?.encounterInfo?.number})`
                }`,
              },
              {
                text: `....................................................`,
                margin: [0, 0, 0, 0],
                pageBreak: ``,
                bold: false,
                decoration: ``,
                fontSize: 15,
                alignment: `left`,
                width: `auto`,
                color: ``,
                decorationStyle: ``,
                decorationColor: ``,
                preserveLeadingSpaces: true,
              },
            ],
          },
          {
            bold: false,
            width: `auto`,
            fontSize: 15,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            color: ``,
            preserveLeadingSpaces: true,
            alignment: `left`,
            text: `เมื่อวันที่`,
            pageBreak: ``,
            margin: [-78, 0, 0, 0],
          },
          {
            color: ``,
            alignment: `left`,
            decoration: ``,
            decorationColor: ``,
            margin: [0, 0, 0, 0],
            pageBreak: ``,
            decorationStyle: ``,
            bold: false,
            fontSize: `10`,
            width: 15,
            text: ``,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                margin: [0, 0, 0, -15],
                bold: false,
                fontSize: 15,
                decorationStyle: ``,
                pageBreak: ``,
                text: props.items?.patientExamDate[0],
                decorationColor: ``,
                preserveLeadingSpaces: true,
                decoration: ``,
                width: `auto`,
                color: ``,
                alignment: `left`,
              },
              {
                decorationColor: ``,
                preserveLeadingSpaces: true,
                bold: false,
                alignment: `left`,
                pageBreak: ``,
                fontSize: 15,
                decorationStyle: ``,
                width: `auto`,
                color: ``,
                decoration: ``,
                text: `....................................................................................`,
                margin: [0, 0, 0, 0],
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            width: `auto`,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            decorationStyle: ``,
            bold: false,
            decorationColor: ``,
            fontSize: 15,
            decoration: ``,
            color: ``,
            alignment: `left`,
            text: `อาการนำ :`,
          },
          {
            decorationColor: ``,
            width: 10,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            decorationStyle: ``,
            alignment: `left`,
            decoration: ``,
            fontSize: 15,
            color: ``,
            text: ``,
            bold: false,
          },
          {
            stack: [
              {
                text:
                  props.items?.chiefComplaint == null || props.items?.chiefComplaint === ""
                    ? " "
                    : props.items?.chiefComplaint,
                decorationColor: ``,
                pageBreak: ``,
                decoration: ``,
                bold: false,
                color: ``,
                alignment: `left`,
                margin: [0, 0, 0, -15],
                preserveLeadingSpaces: true,
                width: `auto`,
                decorationStyle: ``,
                fontSize: 15,
              },
              {
                width: `auto`,
                decorationStyle: ``,
                decoration: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                pageBreak: ``,
                decorationColor: ``,
                text: `......................................................................................................................................................................................`,
                bold: false,
                margin: [0, 0, 0, 0],
                alignment: `left`,
                color: ``,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            width: `auto`,
            decorationColor: ``,
            bold: false,
            alignment: `left`,
            decorationStyle: ``,
            color: ``,
            decoration: ``,
            text: `การวินิจฉัย :`,
            preserveLeadingSpaces: true,
            fontSize: 15,
            pageBreak: ``,
          },
          {
            bold: false,
            fontSize: 15,
            alignment: `left`,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            decoration: ``,
            width: 10,
            decorationColor: ``,
            pageBreak: ``,
            text: ``,
            color: ``,
          },
          {
            stack: [
              {
                pageBreak: ``,
                width: `auto`,
                text:
                  props.items?.diagnosis == null || props.items?.diagnosis === ""
                    ? " "
                    : props.items?.diagnosis,
                decorationStyle: ``,
                color: ``,
                preserveLeadingSpaces: true,
                fontSize: 15,
                decoration: ``,
                decorationColor: ``,
                alignment: `left`,
                margin: [0, 0, 0, -15],
                bold: false,
              },
              {
                decoration: ``,
                width: `auto`,
                text: `...................................................................................................................................................................................`,
                fontSize: 15,
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                decorationColor: ``,
                pageBreak: ``,
                bold: false,
                alignment: `left`,
                margin: [0, 0, 0, 0],
                color: ``,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            width: `auto`,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            text: `ความคิดเห็นแพทย์ :`,
            alignment: `left`,
            fontSize: 15,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            bold: false,
          },
          {
            width: 10,
            preserveLeadingSpaces: true,
            decoration: ``,
            text: ``,
            alignment: `left`,
            decorationStyle: ``,
            fontSize: 15,
            pageBreak: ``,
            bold: false,
            decorationColor: ``,
            color: ``,
          },
          {
            stack: [
              {
                alignment: `left`,
                preserveLeadingSpaces: true,
                bold: false,
                decoration: ``,
                margin: [0, 0, 0, -15],
                width: `auto`,
                pageBreak: ``,
                decorationColor: ``,
                text:
                  props.items?.comment == null || props.items?.comment === ""
                    ? " "
                    : props.items?.comment,
                decorationStyle: ``,
                fontSize: 15,
                color: ``,
              },
              {
                text: `.......................................................................................................................................................................`,
                width: `auto`,
                fontSize: 15,
                decoration: ``,
                margin: [0, 0, 0, 0],
                pageBreak: ``,
                preserveLeadingSpaces: true,
                color: ``,
                decorationColor: ``,
                bold: false,
                decorationStyle: ``,
                alignment: `left`,
              },
            ],
          },
        ],
      },
      {
        margin: [0, 0, 0, 0],
        bold: false,
        fontSize: 15,
        color: ``,
        text: `............................................................................................................................................................................................................`,
        alignment: `left`,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        decoration: ``,
        decorationColor: ``,
        width: `auto`,
        decorationStyle: ``,
      },
      {
        fontSize: 15,
        color: ``,
        margin: [0, 0, 0, 0],
        decoration: ``,
        alignment: `left`,
        preserveLeadingSpaces: true,
        decorationStyle: ``,
        bold: false,
        pageBreak: ``,
        width: `auto`,
        text: `............................................................................................................................................................................................................`,
        decorationColor: ``,
      },
      {
        text: ` `,
        decoration: ``,
        pageBreak: ``,
        width: `auto`,
        bold: false,
        preserveLeadingSpaces: true,
        alignment: `left`,
        color: ``,
        decorationColor: ``,
        decorationStyle: ``,
        fontSize: 15,
      },
      {
        columns: [
          {
            pageBreak: ``,
            fontSize: 15,
            color: ``,
            decorationStyle: ``,
            bold: false,
            alignment: `left`,
            width: `auto`,
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationColor: ``,
            text: `ผู้ป่วยจำเป็นต้องพักงานเป็นระยะเวลา จำนวน`,
          },
          {
            decorationColor: ``,
            text: ``,
            color: ``,
            decorationStyle: ``,
            decoration: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            width: 10,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                pageBreak: ``,
                alignment: `center`,
                text: props.items?.dayDuration,
                width: `auto`,
                bold: false,
                decoration: ``,
                decorationStyle: ``,
                color: ``,
                fontSize: 15,
                decorationColor: ``,
                margin: [0, 0, 0, -15],
                preserveLeadingSpaces: true,
              },
              {
                text: `...............`,
                fontSize: 15,
                decorationStyle: ``,
                color: ``,
                margin: [0, 0, 0, 0],
                width: `auto`,
                bold: false,
                preserveLeadingSpaces: true,
                decorationColor: ``,
                alignment: `left`,
                decoration: ``,
                pageBreak: ``,
              },
            ],
            width: `auto`,
          },
          {
            bold: false,
            preserveLeadingSpaces: true,
            fontSize: 15,
            width: 5,
            decorationStyle: ``,
            decoration: ``,
            pageBreak: ``,
            decorationColor: ``,
            text: ``,
            alignment: `left`,
            color: ``,
          },
          {
            pageBreak: ``,
            color: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            width: `auto`,
            bold: false,
            alignment: `left`,
            decorationStyle: ``,
            fontSize: 15,
            text: `วัน`,
            decorationColor: ``,
            margin: [0, 0, 0, 0],
          },
          {
            decorationColor: ``,
            decoration: ``,
            bold: false,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            text: ``,
            alignment: `left`,
            fontSize: 15,
            pageBreak: ``,
            width: 10,
            color: ``,
          },
          {
            fontSize: 15,
            decoration: ``,
            width: `auto`,
            bold: false,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            alignment: `left`,
            color: ``,
            decorationStyle: ``,
            text: `ตั้งแต่`,
          },
          {
            fontSize: 15,
            decoration: ``,
            preserveLeadingSpaces: true,
            bold: false,
            decorationStyle: ``,
            text: ``,
            decorationColor: ``,
            color: ``,
            alignment: `left`,
            pageBreak: ``,
            width: 10,
          },
          {
            stack: [
              {
                text: props.items?.patientAbsenceStart ? props.items?.patientAbsenceStart : ` `,
                margin: [0, 0, 0, -15],
                decorationStyle: ``,
                pageBreak: ``,
                decoration: ``,
                decorationColor: ``,
                alignment: `center`,
                width: `auto`,
                preserveLeadingSpaces: true,
                bold: false,
                color: ``,
                fontSize: 15,
              },
              {
                width: `auto`,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
                color: ``,
                decoration: ``,
                decorationStyle: ``,
                text: `................................`,
                bold: false,
                alignment: `left`,
                decorationColor: ``,
                fontSize: 15,
              },
            ],
            width: `auto`,
          },
          {
            preserveLeadingSpaces: true,
            decorationColor: ``,
            decoration: ``,
            color: ``,
            pageBreak: ``,
            decorationStyle: ``,
            fontSize: 15,
            width: 5,
            text: ``,
            bold: false,
            alignment: `left`,
          },
          {
            fontSize: 15,
            alignment: `left`,
            text: `ถึง`,
            preserveLeadingSpaces: true,
            width: `auto`,
            bold: false,
            margin: [0, 0, 0, 0],
            decorationStyle: ``,
            decorationColor: ``,
            color: ``,
            pageBreak: ``,
            decoration: ``,
          },
          {
            bold: false,
            text: ``,
            fontSize: 15,
            decorationColor: ``,
            color: ``,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            alignment: `left`,
            width: 10,
            decoration: ``,
          },
          {
            stack: [
              {
                decorationStyle: ``,
                fontSize: 15,
                pageBreak: ``,
                bold: false,
                decoration: ``,
                preserveLeadingSpaces: true,
                decorationColor: ``,
                text: props.items?.patientAbsenceEnd ? props.items?.patientAbsenceEnd : ` `,
                alignment: `center`,
                margin: [0, 0, 0, -15],
                color: ``,
                width: `auto`,
              },
              {
                text: `.....................................`,
                bold: false,
                decorationColor: ``,
                decorationStyle: ``,
                color: ``,
                alignment: `left`,
                decoration: ``,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                width: `auto`,
                fontSize: 15,
                margin: [0, 0, 0, 0],
              },
            ],
            width: `auto`,
          },
        ],
      },
      {
        pageBreak: ``,
        preserveLeadingSpaces: true,
        text: ` `,
        decoration: ``,
        alignment: `left`,
        color: ``,
        bold: false,
        decorationStyle: ``,
        decorationColor: ``,
        width: `auto`,
        fontSize: 15,
      },
      {
        fontSize: 15,
        decorationStyle: ``,
        decoration: ``,
        color: ``,
        width: `auto`,
        text: ` `,
        pageBreak: ``,
        decorationColor: ``,
        preserveLeadingSpaces: true,
        bold: false,
        alignment: `left`,
      },
      {
        preserveLeadingSpaces: true,
        width: `auto`,
        decorationColor: ``,
        color: ``,
        decorationStyle: ``,
        bold: false,
        decoration: ``,
        fontSize: 15,
        pageBreak: ``,
        alignment: `left`,
        text: ` `,
      },
      {
        decorationStyle: ``,
        text: `  `,
        decoration: ``,
        alignment: `left`,
        bold: false,
        width: `auto`,
        preserveLeadingSpaces: true,
        color: ``,
        fontSize: 15,
        pageBreak: ``,
        decorationColor: ``,
      },
      {
        columns: [
          {
            stack: [
              {
                text: `.......................................................`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `center`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
              {
                text: `(${props.items?.doctorName})`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `center`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
              {
                text: `ลงนามแพทย์ผู้ตรวจ`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `center`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
          },
          {
            stack: [
              {
                text: `.......................................................`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `center`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
              {
                text: `(${props.items?.patientInfo?.full_name})`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `center`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
              {
                text: `ลงนามผู้ป่วย`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `center`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
          },
        ],
      },
    ],
    pageSize: `A4`,
    defaultStyle: {
      font: `THSarabunNew`,
    },
    pageOrientation: `portrait`,
    header: props.header,
    footer: props.footer,
  };
}
